import {
  AfterViewInit,
  Component,
  EventEmitter,
  Input,
  OnChanges,
  OnDestroy,
  OnInit,
  Output,
  SimpleChanges
} from '@angular/core';
import {FormBuilder, FormGroup, Validators} from "@angular/forms";
import {HttpCustomService} from "../../../../../service/http-custom.service";
import {BsModalService} from "ngx-bootstrap/modal";
import {Station} from "../../../../../shared/model/station";
import {Subject} from "rxjs/Rx";
import * as _ from 'lodash';
import {checkUniqueStationCode} from "../../../../../shared/validator/station-validator";
import {Cooperative} from "../../../../../shared/model/cooperative";

@Component({
  selector: 'omni-station-info',
  templateUrl: './station-info.component.html',
  styleUrls: ['./station-info.component.scss']
})
export class StationInfoComponent implements OnInit, OnDestroy, OnChanges, AfterViewInit {

  formGroup: FormGroup;
  @Output() valueChange: EventEmitter<any> = new EventEmitter();
  @Input() station: Station;
  ngUnsubscribe: Subject<any> = new Subject();
  @Input() isEdit = false;
  defaultValue: Station = {};
  @Input() cooperative: Cooperative;
  cooperativeName = '';
  cooperativeNo: number;

  constructor(
    private fb: FormBuilder,
    private dialogService: BsModalService,
    private http: HttpCustomService,
  ) { }

  ngOnChanges(changes: SimpleChanges): void {
    if (changes.station && !_.isEqual(changes.station.previousValue, changes.station.currentValue) && !_.isEmpty(this.station)) {
      if (_.isNil(this.formGroup)) {
        this.buildForm();
      }
      setTimeout(() => {
        this.formGroup.patchValue({
          cooperativeNo: this.station.cooperativeNo,
          stationNo: this.station.stationNo,
          stationName: this.station.stationName,
          stationCode: this.station.stationCode,
        });
        _.assign(this.defaultValue, this.formGroup.getRawValue());
      });
    }
  }

  ngOnInit(): void {
    this.cooperativeName = this.cooperative?.cooperativeName || this.station?.cooperativeName;
    this.cooperativeNo = this.cooperative?.cooperativeNo || this.station?.cooperativeNo;
    if (!this.isEdit) {
      this.buildForm();
    }
  }

  buildForm(): void {
    this.formGroup = this.fb.group({
      cooperativeNo: [this.cooperativeNo, [Validators.required]],
      stationNo: [null],
      stationCode: [null, [Validators.required]],
      stationName: [null],
    });
    this.formGroup.get('stationCode').setAsyncValidators(checkUniqueStationCode(this.http));
  }

  ngOnDestroy(): void {
    this.ngUnsubscribe.next();
    this.ngUnsubscribe.complete();
  }

  ngAfterViewInit() {
    _.assign(this.defaultValue, this.formGroup.getRawValue());
  }
}

